import React from "react";

import styles from "../../styles/order-details.module.scss";
import { Currency } from "../utils/Currency";
import { Method, PaymentMethod } from "../utils/Payment";

// import { convertMoney } from "../utils";

export default class Payers extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	getPaymentMethod(payer) {
		const { paymentMethod } = payer;
		
		let pMString = '';
		if ((paymentMethod & PaymentMethod.CREDIT) === PaymentMethod.CREDIT) {
			pMString = "Crédito";
		} else if ((paymentMethod & PaymentMethod.DEBIT) === PaymentMethod.DEBIT) {
			pMString = "Débito";
		} else if ((paymentMethod & PaymentMethod.VOUCHER) === PaymentMethod.VOUCHER) {
			pMString = "Voucher";
		} else if ((paymentMethod & PaymentMethod.MONEY) === PaymentMethod.MONEY) {
			return payer.changeFor !== null ? `(Troco para ${Currency.formatCurrency(payer.changeFor || 0)})` : '';
		}
	
		if ((paymentMethod & PaymentMethod.ONLINE) === PaymentMethod.ONLINE) {
			pMString += ' ';
			pMString += "Online";
		}
	
		if (PaymentMethod.ONLINE + PaymentMethod.MONEY + PaymentMethod.DEBIT === paymentMethod) {
			pMString = payer.MethodType.replace("-", " - ");
		}
		 else if ((paymentMethod & PaymentMethod.FISICO) === PaymentMethod.FISICO) {
			pMString += ' ';
			pMString += "na Entrega"
		}
	   
		return `(${pMString})`;
	}

	render() {
		const { order } = this.props;
		const { payment } = order;

		return (
			<div className={styles.payers}>
				<p>Pagantes</p>
				{
					payment.payers.map((payer, payerIndex) => {
						return (
							<div className={styles.payer}>
								<span className={styles.payerAlias}>Pagante {payerIndex + 1}</span>
								<div className="d-flex align-center justify-between">
									<span className={styles.paymentMethod}>{ Method[payer.method] && Method[payer.method].name } {this.getPaymentMethod(payer)}</span>
									<p className={styles.value}>{Currency.formatCurrency(payer.amount)}</p>
								</div>
							</div>
						)
					})
				}

			</div>
		);
	}
}
